import React from 'react';
import useBgPages from '../../../../hooks/use-bg-pages.hook';
import Input from '../../../../components/forms/input.component';
import TextAreaRCS from '../../../../components/forms/text-area-rcs.component';
import SimpleTitle from '../../../../components/forms/simple-titles.component';
import { useFunctionsButtons } from '../../../../hooks/use-function-button.hook';

function calendarButton({
  actionIndex,
  actionIndexCarrousel,
  actionIndexSugestionsGeneral,
  index,
  indexCarrosuel,
  cardIndex,
  type,
  payload,
  payloadCarrousel
}: {
  actionIndex?: any;
  actionIndexCarrousel?: any;
  actionIndexSugestionsGeneral?: any;
  index?: any;
  indexCarrosuel?: any;
  cardIndex?: any;
  type?: string;
  payload?: any;
  payloadCarrousel?: any;
}) {
  useBgPages();

  const {
    t,
    register,
    watch,
    setValue,
    errors,
    handleRemoveAction,
    handleKeyDown,
    handleRemoveActionCard,
    handleRemoveSuggestion
  } = useFunctionsButtons();

  return (
    <React.Fragment
      key={`action-calendar-${type === 'richCard' ? actionIndex : type === 'richCardCarrousel' ? actionIndexCarrousel : actionIndexSugestionsGeneral}`}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <SimpleTitle
          title="Calendario"
          type="info fw-bolder"
          subtitle={`Botón ${type === 'richCard' ? actionIndex + 1 : type === 'richCardCarrousel' ? actionIndexCarrousel + 1 : actionIndexSugestionsGeneral + 1}`}
        />
        <button
          type="button"
          className="btn btn-link text-danger fw-bolder p-0"
          onClick={() => {
            if (type === 'richCard') {
              handleRemoveAction(index, actionIndex);
            } else if (type === 'richCardCarrousel') {
              handleRemoveActionCard(indexCarrosuel, cardIndex, actionIndexCarrousel);
            } else if (type === 'suggestionsGeneral') {
              handleRemoveSuggestion(actionIndexSugestionsGeneral);
            }
          }}
        >
          Eliminar
        </button>
      </div>
      {type === 'richCard' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.general-tag')}
              requiredIndicator="required"
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (watch(`elements.${index}.actions.${actionIndex}.gnlLabel`) as string)?.length || 0
              }
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.gnlLabel}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`elements.${index}.actions.${actionIndex}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.title-event-label')}
              requiredIndicator="required"
              placeholder="Ingresa título"
              currentLength={
                (watch(`elements.${index}.actions.${actionIndex}.titleC`) as string)?.length || 0
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`elements.${index}.actions.${actionIndex}.titleC`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.titleC}
            />
          </div>
          <div className="col-md-12 mb-5">
            <TextAreaRCS
              requiredIndicator="required"
              disableEmojis={true}
              label={t('general.description')}
              inputName={`elements.${index}.actions.${actionIndex}.descriptionC`}
              payload={
                payload?.rows?.basic?.text
                  ? {
                      message: payload.rows.basic.text
                    }
                  : ''
              }
              placeholder={t('templates.rcs.create.message-placeholder')}
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.descriptionC}
              counter={2000}
              setValue={setValue}
              {...register(`elements.${index}.actions.${actionIndex}.descriptionC`, {
                required: true,
                maxLength: {
                  value: 2000,
                  message: '2000'
                }
              })}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Fecha y hora de inicio (UTC)"
              requiredIndicator="required"
              placeholder="Ej. 2025-04-22T14:00:00Z"
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.startTime}
              {...register(`elements.${index}.actions.${actionIndex}.startTime`, {
                required: true,
                pattern: {
                  value: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/,
                  message: 'Formato inválido. Ejemplo: 2025-04-22T14:00:00Z'
                }
              })}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Fecha y hora de fin (UTC)"
              requiredIndicator="required"
              placeholder="Ej. 2025-04-22T16:00:00Z"
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.endTime}
              {...register(`elements.${index}.actions.${actionIndex}.endTime`, {
                required: true,
                pattern: {
                  value: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/,
                  message: 'Formato inválido. Ejemplo: 2025-04-22T16:00:00Z'
                }
              })}
            />
          </div>
        </div>
      )}
      {type === 'richCardCarrousel' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.general-tag')}
              requiredIndicator="required"
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (
                  watch(
                    `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`
                  ) as string
                )?.length || 0
              }
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.gnlLabel
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`,
                {
                  required: true,
                  maxLength: {
                    value: 25,
                    message: 'Máximo 25 caracteres'
                  }
                }
              )}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.title-event-label')}
              requiredIndicator="required"
              placeholder="Ingresa título"
              currentLength={
                (
                  watch(
                    `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.titleC`
                  ) as string
                )?.length || 0
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.titleC`,
                {
                  required: true,
                  maxLength: {
                    value: 25,
                    message: 'Máximo 25 caracteres'
                  }
                }
              )}
              maxLength={25}
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.titleC
              }
            />
          </div>
          <div className="col-md-12 mb-5">
            <TextAreaRCS
              requiredIndicator="required"
              disableEmojis={true}
              label={t('general.description')}
              inputName={`elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.descriptionC`}
              payload={
                payloadCarrousel?.rows?.basic?.text
                  ? {
                      message: payloadCarrousel.rows.basic.text
                    }
                  : ''
              }
              placeholder={t('templates.rcs.create.message-placeholder')}
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.descriptionC
              }
              counter={2000}
              setValue={setValue}
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.descriptionC`,
                {
                  required: true,
                  maxLength: {
                    value: 2000,
                    message: '2000'
                  }
                }
              )}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Fecha y hora de inicio (UTC)"
              requiredIndicator="required"
              placeholder="Ej. 2025-04-22T14:00:00Z"
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.startTime
              }
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.startTime`,
                {
                  required: true,
                  pattern: {
                    value: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/,
                    message: 'Formato inválido. Ejemplo: 2025-04-22T14:00:00Z'
                  }
                }
              )}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Fecha y hora de fin (UTC)"
              requiredIndicator="required"
              placeholder="Ej. 2025-04-22T16:00:00Z"
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.endTime
              }
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.endTime`,
                {
                  required: true,
                  pattern: {
                    value: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/,
                    message: 'Formato inválido. Ejemplo: 2025-04-22T16:00:00Z'
                  }
                }
              )}
            />
          </div>
        </div>
      )}
      {type === 'suggestionsGeneral' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.general-tag')}
              requiredIndicator="required"
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (watch(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`) as string)?.length ||
                0
              }
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.gnlLabel}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.title-event-label')}
              requiredIndicator="required"
              placeholder="Ingresa título"
              currentLength={
                (watch(`suggestions.${actionIndexSugestionsGeneral}.titleC`) as string)?.length || 0
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.titleC`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.titleC}
            />
          </div>
          <div className="col-md-12 mb-5">
            <TextAreaRCS
              requiredIndicator="required"
              disableEmojis={true}
              label={t('general.description')}
              inputName={`suggestions.${actionIndexSugestionsGeneral}.descriptionC`}
              payload={
                payload?.rows?.basic?.text
                  ? {
                      message: payload.rows.basic.text
                    }
                  : ''
              }
              placeholder={t('templates.rcs.create.message-placeholder')}
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.descriptionC}
              counter={2000}
              setValue={setValue}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.descriptionC`, {
                required: true,
                maxLength: {
                  value: 2000,
                  message: '2000'
                }
              })}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Fecha y hora de inicio (UTC)"
              requiredIndicator="required"
              placeholder="Ej. 2025-04-22T14:00:00Z"
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.startTime}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.startTime`, {
                required: true,
                pattern: {
                  value: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/,
                  message: 'Formato inválido. Ejemplo: 2025-04-22T14:00:00Z'
                }
              })}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Fecha y hora de fin (UTC)"
              requiredIndicator="required"
              placeholder="Ej. 2025-04-22T16:00:00Z"
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.endTime}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.endTime`, {
                required: true,
                pattern: {
                  value: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/,
                  message: 'Formato inválido. Ejemplo: 2025-04-22T16:00:00Z'
                }
              })}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default calendarButton;
